var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3058 0.379443L16.5918 6.37966C16.7614 6.54148 16.8574 6.76585 16.8574 7.00021C16.8574 7.23458 16.7614 7.45895 16.5918 7.62077L10.3058 13.621C9.96321 13.9469 9.42076 13.9346 9.09375 13.592C8.76674 13.2527 8.77899 12.708 9.12275 12.3799L13.8611 7.85739L1.7146 7.85739C1.24136 7.85739 0.857422 7.47345 0.857422 7.00022C0.857422 6.52698 1.24136 6.14304 1.71459 6.14304L13.8611 6.14304L9.12279 1.62056C8.77903 1.29355 8.76674 0.748884 9.09375 0.408478C9.42076 0.0658241 9.96321 0.0535379 10.3058 0.379443Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.87286537a6fe5f5bbec30dc8fe1b0a55.svg";
export { ForwardRef as ReactComponent };